<template>
    <div>
        播放器
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    props:['courseInfo'],
    data () {
        return {

        }
    },
    mounted(){
        this.getprops()
    },
    methods:{
        getprops(){
            // console.log(this.JsonData)
        }
    },
    watch:{
        courseInfo(val){
            // console.log(val)
        }
    },
    computed: {
        ...mapState({
            JsonData :state => state.control.JsonData,
        })
    },
}
</script>


// WEBPACK FOOTER //
// src/views/video/videoPage.vue